import { useMutation } from "@apollo/client/react";
import { TRIGGER_RISK_SCORE_DETERMINATION } from "../../mutations/aml/triggerRiskScoreDetermination";
import GET_CLIENT_RISK_SCORE from "../../queries/aml/getClientRiskScore";
import GET_CLIENT_MONITORING_EVENTS from "../../queries/aml/getClientMointoringEvents";

export const useTriggerRiskScoreDetermination = ({
  onCompleted,
  onError,
}: any) => {
  const [triggerRiskScoreDetermination, { data, loading, error }] = useMutation(
    TRIGGER_RISK_SCORE_DETERMINATION,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_CLIENT_RISK_SCORE, GET_CLIENT_MONITORING_EVENTS],
      awaitRefetchQueries: true,
    }
  );

  return { triggerRiskScoreDetermination, data, loading, error };
};
